<template>
  <DatatableReportV3
    title="Customer Contact Report"
    :config="config"
    :source="source"
    :filters="filters"
    :no-download="noDownload"
  />
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    },
    noDownload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      config: {
        order: [[1, "asc"]],
        columns: [
          { data: "id", orderable: false },
          { data: "name", className: "name-field" },
          { data: "email", className: "email-field" },
          { data: "phone", className: "phone-field" },
          { data: "tags", title: "Tags", orderable: false, searchable: false },
          { data: "location_name", title: "Location Name" },
          {
            data: "address",
            orderable: false,
            className: "address-field"
          },
          { data: "primary", title: "Billing Address?" },
          {
            data: "zip_code",
            title: "Zip",
            className: "zipcode-field"
          },
          {
            data: "membership_status",
            title: "Member Status",
            searchable: false,
            className: "membership-status-field",
            filterName: "membership_status"
          },
          {
            data: "accounting_key",
            title: "Accounting Key",
            searchable: false
          },
          {
            data: "invoice_count",
            title: "# of Invoices",
            className: "text-center",
            orderable: false,
            searchable: false
          },
          {
            data: "most_recent_invoice",
            title: "Last Invoice",
            filterName: "last_job",
            orderable: false,
            searchable: false
          },
          {
            data: "total_invoices_value",
            title: "Total Invoiced",
            className: "text-right",
            orderable: false,
            searchable: false
          },
          {
            data: "customer_created_date",
            title: "Customer Created Date",
            className: "text-center",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Customer Contact Report" });
  }
};
</script>

<style lang="scss" scoped></style>
